import { gql } from "@apollo/client";
import useGQLMutation from "src/lib/graphql/hooks/useGQLMutation";
import { useHandleMutationCompleted } from "../../components/contributions/hooks/useHandleMutationCompleted";
import { EP_QUESTION_DETAILS_QUERY } from "../question/getQuestionDetails";
const CREATE_EF_MUTATION = gql `
  mutation EP_CreateEF($questionID: String!, $data: EPEFInput!) {
    ep_createEF(questionID: $questionID, data: $data) {
      sentForReview
    }
  }
`;
export function useCreateEFMutation(options) {
    const handleMutationCompleted = useHandleMutationCompleted();
    return useGQLMutation(CREATE_EF_MUTATION, {
        ...options,
        refetchQueries(result) {
            if (!result.data?.ep_createEF.sentForReview) {
                return [EP_QUESTION_DETAILS_QUERY];
            }
            return [];
        },
        onCompleted(data) {
            handleMutationCompleted(data.ep_createEF);
        },
    });
}
